/**
 * Formats a dimension value (cm) to a string (m/cm).
 * Rules: > 99cm -> convert to m (e.g. 150 -> 1.50 m).
 */
export const formatDimension = (value) => {
    if (!value && value !== 0) return '';
    const num = parseInt(value, 10);
    if (isNaN(num)) return value; // Return as is if not a number

    if (num > 99) {
        // Convert to meters, 2 decimal places if needed, or just standard string
        // 120 -> 1.2 m, 100 -> 1 m
        const m = num / 100;
        // Use German locale for decimal separator (comma)
        return `${m.toLocaleString('de-DE', { maximumFractionDigits: 2 })} m`;
    }
    return `${num} cm`;
};

/**
 * Returns the localized display value for a plant field.
 * Looks for 'field_display' property, falls back to 'field'.
 */
export const getLocalizedValue = (plant, fieldName) => {
    if (!plant) return '';
    const displayKey = `${fieldName}_display`;
    if (plant[displayKey]) return plant[displayKey];
    return plant[fieldName] || '';
};
